import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { PhoneInventoryTableHeader } from './PhoneInventoryTableHeader';

export const PhoneInventoryDataTable = props => {
  if (!props.phones || props.phones.length === 0) {
    return (
      <React.Fragment>
        <Table celled selectable sortable>
          <PhoneInventoryTableHeader
            column={props.column}
            direction={props.direction}
            handleSort={props.handleSort}
            header={props.tableHeader}
            checkAll={props.checkAll}
          />
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="6" textAlign="center">
                {props.loading ? 'Loading phone numbers...' : 'No phone numbers found.'}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Table celled selectable sortable>
        <PhoneInventoryTableHeader
          column={props.column}
          direction={props.direction}
          handleSort={props.handleSort}
          header={props.tableHeader}
          checkAll={props.checkAll}
        />
        <Table.Body>{props.phoneRows}</Table.Body>
      </Table>
    </React.Fragment>
  );
};

PhoneInventoryDataTable.propTypes = {
  phones: PropTypes.array.isRequired,
  tableHeader: PropTypes.array.isRequired,
  phoneRows: PropTypes.any.isRequired,
  column: PropTypes.string,
  direction: PropTypes.string,
  handleSort: PropTypes.func.isRequired,
  checkAll: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};
